/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Group_ContactInputs */

const en_enum_setting_group_contact = /** @type {(inputs: Enum_Setting_Group_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Contact`)
};

const de_enum_setting_group_contact = /** @type {(inputs: Enum_Setting_Group_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe Contact`)
};

/**
* | output |
* | --- |
* | "Group Contact" |
*
* @param {Enum_Setting_Group_ContactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_group_contact = /** @type {((inputs?: Enum_Setting_Group_ContactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Group_ContactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_group_contact(inputs)
	return de_enum_setting_group_contact(inputs)
});